module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("page_0041_master_system_detail")]) : _vm._e(), _vm._v(" "), _c('app-header', [_vm._v("esma")]), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('title-and-slot', {
    attrs: {
      "title": "メールメッセージ詳細"
    }
  }, [_c('div')]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('label', {
    attrs: {
      "for": "subject"
    }
  }, [_vm._v("件名")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mailSubject),
      expression: "mailSubject"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "subject",
      "id": "subject"
    },
    domProps: {
      "value": (_vm.mailSubject)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mailSubject = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('label', {
    attrs: {
      "for": "content"
    }
  }, [_vm._v("本文")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mailContent),
      expression: "mailContent"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "content",
      "id": "content",
      "cols": "30",
      "rows": "10"
    },
    domProps: {
      "value": (_vm.mailContent)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mailContent = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "margin": "20px 0px"
    }
  }, [_c('master-user', {
    attrs: {
      "searchData": _vm.selectedUserIDs,
      "showSearch": false,
      "showDetailsButtons": false,
      "allUserIds": false,
      "refreshTag": "selectedUsersRefresh",
      "showCheckBox": true,
      "subSearchMode": "only",
      "tabStyle": "width: 100%; height: 200px"
    },
    on: {
      "email_list_updated": _vm.emailListUpdated,
      "selected": _vm.onSelectedUserSelected
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "left",
      "margin-left": "-10px"
    },
    on: {
      "click": _vm.backToList
    }
  }, [_vm._v("＜　戻る")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "margin-right": "5px"
    },
    on: {
      "click": _vm.addUsers
    }
  }, [_vm._v("ユーザ追加")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "margin-right": "5px"
    },
    on: {
      "click": _vm.removeUsers
    }
  }, [_vm._v("ユーザ選択解除")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "margin-right": "5px"
    },
    on: {
      "click": _vm.prepareSendMail
    }
  }, [_vm._v("メール作成")]), _vm._v(" "), _c('a', {
    ref: "send_mail_link",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "target": "new_email"
    }
  }, [_vm._v("mailto")])])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-441ecc1c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/page_0081_mail_message_create.vue
// module id = 972
// module chunks = 0